import { useState } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { PoClosureSearchResult } from "models/po-closure";
import { useAuth } from "src/contexts/AuthContext";

interface CreatePoClosureRequestResult {
  requestId: string;
  status: string;
  deduplicated: boolean;
}

export const useCreatePoClosureRequest = () => {
  const [result, setResult] = useState<CreatePoClosureRequestResult | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { fetchWithReauth } = useAuth();

  const createPoClosureRequest = async (
    selectedPo: PoClosureSearchResult,
    reason: string,
  ) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchWithReauth(`${API_URL}/po-closures`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          poInternalId: selectedPo.internalId,
          poNumber: selectedPo.tranId,
          vendorId: selectedPo.vendorId,
          vendorName: selectedPo.vendorName,
          reason,
          memoBefore: selectedPo.memo,
          currency: selectedPo.currency,
          amountTotal: selectedPo.amountTotal,
          amountRemaining: selectedPo.amountRemaining,
          subsidiaryId: selectedPo.subsidiaryId,
          subsidiaryName: selectedPo.subsidiaryName,
          statusAtSubmission: selectedPo.status,
        }),
      });
      const data = (await checkResponse(response)) as CreatePoClosureRequestResult;
      setResult(data);
      return data;
    } catch (requestError) {
      console.error("Error creating PO closure request:", requestError);
      setError("Failed to submit PO closure request.");
      throw requestError;
    } finally {
      setLoading(false);
    }
  };

  return { result, loading, error, createPoClosureRequest };
};
